import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import createPersistedState from 'vuex-persistedstate';

import createSagaPlugin from '~/lib/vuex-redux-saga';
import analytics from './analytics';
import api from './api';
import appUpdates from './appUpdates';
import auth from './auth';
import breadcrumbs from './breadcrumbs';
import config from './config';
import contacts from './contacts';
import currencyRates from './currencyRates';
import discountDialog from './discountDialog';
import eetForm from './eetForm';
import env from './env';
import file from './file';
import flashMessages from './flashMessages';
import invoiceForm from './invoiceForm';
import invoices from './invoices';
import lineSuggestions from './lineSuggestions';
import reports from './reports';
import sagas from './sagas';
import savedLines from './savedLines';
import settingsForm from './settingsForm';
import signUp from './signUp';
import statistics from './statistics';
import submitInvoiceForm from './submitInvoiceForm';
import uiEffects from './uiEffects';

Vue.use(Vuex);

const sagaPlugin = createSagaPlugin();

const debug = process.env.NODE_ENV === 'development';

const loggerPlugin = debug ? [createLogger()] : [];

const globalPlugins = [
  createPersistedState({
    paths: [
      'auth.authStatus',
      'auth.keepMeSignedIn',
      'auth.tokens',
      'auth.user',
      'flashMessages',
    ],
  }),
  sagaPlugin,
];

const store = new Vuex.Store({
  modules: {
    analytics,
    api,
    appUpdates,
    auth,
    breadcrumbs,
    config,
    contacts,
    currencyRates,
    discountDialog,
    eetForm,
    env,
    file,
    flashMessages,
    invoiceForm,
    invoices,
    lineSuggestions,
    reports,
    savedLines,
    settingsForm,
    signUp,
    statistics,
    submitInvoiceForm,
    uiEffects,
  },
  plugins: [...globalPlugins, ...loggerPlugin],
});

sagas.forEach(sagaPlugin.run);

export default store;
